import TextAreaInput from '@/core/components/inputs/TextAreaInput/TextAreaInput';

export default TextAreaInput;
